exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recent .route-title {\n  padding: 40px 40px;\n  padding-bottom: 0px;\n}\n\n.recent .patients h1,\n.recent .examinations h1 {\n  font-size: 20pt;\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n\n.recent .patients .patients-grid,\n.recent .examinations .examinations-grid {\n  margin-bottom: 20px;\n}\n\n.recent{\n  padding-bottom: 40px;\n}\n", ""]);

// exports
